import { createPersistStore } from '@shared/store'

interface CfdPushState {
  sessionToken: string
  pushEnabled: boolean | null
  setSessionToken: (sessionToken: string) => void
  clearSessionToken: () => void
  setPushEnabled: (pushEnabled: boolean) => void
}

export const useCfdPushStore = createPersistStore<CfdPushState>('cfd-push-session', set => ({
  sessionToken: '',
  pushEnabled: null,
  setSessionToken: sessionToken => set({ sessionToken }),
  clearSessionToken: () => set({ sessionToken: '' }),
  setPushEnabled: pushEnabled => set({ pushEnabled }),
}))
